export default __webpack_public_path__ + "static/media/loader.4ae56768.svg";